import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from "react";
import classNames from "classnames";
import { Divider } from "../../components/Divider";
import { Button } from "../../components/Button";
import { constants } from "./utils/constants";
import { LazyImage } from "../../components/LazyImage";
import { DEFAULT_LANGUAGE } from "../../components/LanguageSelector/constants";
// styles
import "./errorPage.scss";
// use the optional prop interface to define the default props
const defaultProps = {
    language: DEFAULT_LANGUAGE,
    "data-testid": "tecma-errorPage",
};
const ErrorPage = ({ className, errorMsg, language = DEFAULT_LANGUAGE, errorCause, errorSolution, buttonLabel, buttonOnClick, logo, }) => {
    const classList = classNames("tecma-errorPage", className);
    const handleButtonClick = (e) => buttonOnClick ? buttonOnClick(e) : window.location.reload();
    return (_jsx("div", { className: classList, children: _jsxs("div", { className: "errorPage-container", children: [_jsx("h1", { className: "errorPage-errorMsg", children: errorMsg || constants[language].errorMsg }), _jsx(Divider, {}), _jsxs("div", { className: "errorPage-desc", children: [_jsxs("span", { children: [errorCause || constants[language].errorCause, " "] }), errorSolution || constants[language].errorSolution] }), _jsx(Button, { onClick: handleButtonClick, color: "primary", children: buttonLabel || constants[language].buttonLabel }), logo && _jsx(LazyImage.Image, { src: logo, errorElement: _jsx(_Fragment, { children: " " }), loadingElement: _jsx(_Fragment, { children: " " }) })] }) }));
};
ErrorPage.defaultProps = defaultProps;
export default React.memo(ErrorPage);
